import React from "react";
import Navbar from "../Components/Navbar";
import HelpMessage from "../Components/HelpMessage";
import SearchBar from "../Components/SearchBar";

const appfieldsData = [
  { heading: "Person/Org Nr", value: "5512273631" },
  { heading: "Titel 1", value: "Ägare" },
  { heading: "Kontakt 1", value: "Anders Johnsson" },
  { heading: "Kontakt 1 Mobil", value: "0708-839312" },
  { heading: "Titel 2", value: "Ägare" },
  { heading: "Kontakt 2", value: "Lena Johnsson" },
  { heading: "Släpvagnstillägg", value: "J" },
  { heading: "Mj syst Robot", value: "J" },
  { heading: "Mj syst Conv.", value: "-" },
  { heading: "Kontakt 4 Mobil", value: "-" },
  { heading: "Hämtadress/Pickup	", value: "Rörum Aspekulle" },
  { heading: "Post nr	", value: "272 95" },
  { heading: "Post ort	", value: "Simrishamn" },
  { heading: "KO=K/PG=P/BG=G	", value: "-" },
  { heading: "Oberoende hämt	", value: "J" },
];

const AppField = () => {
  return (
    <>
      <div className="container-login100">
        <div className="wrap-login100">
          <Navbar />
          <div className="tableft">
            <a>Appfields</a>
          </div>
          <div className="" id="result-wrapper">
            <SearchBar />

            <form id="frmViewAppfileds" method="post">
              <table className="tblViewNotes" id="resultdetail">
                <tbody>
                  <tr className="heading">
                    <td className="viewnotes_incident">Heading</td>
                    <td className="viewnotes_date">Value</td>
                  </tr>
                  {appfieldsData.map((field, index) => (
                    <tr key={index}>
                      <td className={index % 2 === 0 ? "odd" : ""}>
                        {field.heading}
                      </td>
                      <td className={index % 2 === 0 ? "odd" : ""}>
                        {field.value}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <HelpMessage />
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AppField;
